import React, { createContext, useState, useCallback, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import firebase from '../utils/firebase';
import { NotificationContext } from './NotificationProvider';
import { LoggedUserContext } from './LoggedUserProvider';


export const DataContext = createContext([null, () => {}, null, () => {}]);

export const DataProvider = ({ children }) => {
    const history = useHistory();
    const db = firebase.firestore();
    const [, setText] = useContext(NotificationContext);
    const [loggedUser] = useContext(LoggedUserContext);
    const [registration, _setRegistration] = useState({});
    const [daily, _setDaily] = useState({});

    const setRegistration = useCallback((r) => _setRegistration(r), [_setRegistration]);
    const setDaily = useCallback((d) => _setDaily(d), [_setDaily]);

    useEffect(() => {
        console.log('the user', loggedUser);
        const getData = async () => {
            if (loggedUser && loggedUser.indexOf('@') <= -1) {
                console.log('Running get data');
                const userRef = db.collection('registrations').doc(loggedUser);
                const userDailyRef = db.collection('records').doc(loggedUser);
    
                const user = await userRef.get();
                if (user.data()) {
                    console.log('USER DATA', user.data());
                    setRegistration(user.data());
                }

                const userDaily = await userDailyRef.get();
                console.log(userDaily.data());
                if (userDaily.data()) {
                    setDaily(userDaily.data());
                }
            }
        };
        getData();
    }, [loggedUser, db, setDaily, setRegistration, history, setText]);

    return (
        <DataContext.Provider value={[registration, setRegistration, daily, setDaily]}>
            {children}
        </DataContext.Provider>
    );
};
